// extracted by mini-css-extract-plugin
module.exports = {"main-menu":"_3qO0q_","main-menu__logo":"GRVthQ","main-menu__language-switcher-wrapper":"ZiD2mi","main-menu__language-switcher-icon":"z1K9bf"};